import { UserManager } from 'oidc-client-ts';
import { AUTH_ENDPOINT } from '../constants';

export const ChampUserManager = new UserManager({
  authority: AUTH_ENDPOINT(),
  client_id: 'champ',
  redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'champ offline_access',
  loadUserInfo: true,
  automaticSilentRenew: true,
  revokeTokensOnSignout: true,
  revokeTokenTypes: ['access_token', 'refresh_token'],
  fetchRequestCredentials: 'include',
});
